'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIImage from 'UIComponents/image/UIImage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';

const IconListItem = ({
  iconUrl,
  title
}) => {
  return /*#__PURE__*/_jsx(UIMediaObject, {
    className: "m-bottom-2",
    align: "start",
    itemLeft: /*#__PURE__*/_jsx(UIImage, {
      height: "20px",
      width: "20px",
      src: iconUrl
    }),
    children: title
  });
};

IconListItem.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default IconListItem;